import React from 'react';
import { Route } from 'react-router';
import { getCurrentUser } from '@core/utils/currentUser';
import OverlayLoader from '../components/containers/OverlayLoader';
import UserBar from '../components/presentational/Navigation/UserBarToggle';
import AllSpacesPage from '../components/presentational/AllSpaces/AllSpacesPage';
import withSuspense from '../components/presentational/common/Suspense/Suspense';
import { fetchInitialData } from './Dashboard';

const getOnAllSpacesEnter =
  (queryClient: any, ldClient: any) => async (nextState: any, replace: any) => {
    if (!getCurrentUser()) {
      replace({
        pathname: '/logout',
        state: { nextPathname: nextState.location.pathname },
      });
      return;
    }
    await fetchInitialData(queryClient, ldClient);
  };

const AllSpacesRoute = (queryClient: any, ldClient: any) => (
  <Route
    path="all-spaces"
    components={{
      overlayLoader: OverlayLoader,
      userBar: UserBar,
      content: withSuspense(AllSpacesPage),
    }}
    onEnter={getOnAllSpacesEnter(queryClient, ldClient)}
  />
);

export default AllSpacesRoute;
